import { Abas } from '@core/components/Abas';
import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import LoadingModal from 'app/components/LoadingProgress/LoadingModal';
import cancelarAlert from 'app/services/alerts/cancelarAlert';
import * as Actions from 'app/store/actions';
import { calcularValorComDesconto } from 'app/utils/monetarioUtil';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import SockJsClient from 'react-stomp';
import * as Yup from 'yup';
import { ServicoContext } from '../../../ServicoContext';
import { servicoModais } from '../servicoModais';
import TabDadosFiscaisServico from './TabDadosFiscaisServico';
import TabDadosServico from './TabDadosServico';

const tabs = {
  dadosServico: 0,
  dadosFiscais: 1,
};

const EditarServicoModal = ({
  onSubmit,
  openLoadingModal,
  setOpenLoadingModal,
  progressoLoading,
  setProgressoLoading,
  idNotificacao,
  setFuncaoClose,
}) => {
  const [modal, setModal] = useContext(ServicoContext).modal;
  const [servico] = useContext(ServicoContext).servicoAtual;
  const [search] = useContext(ServicoContext).search;
  const INFORME_O_VALOR = 'Informe o valor de venda para ser aplicado o desconto.';
  const [tabSelecionada, setTabSelecionada] = useState(0);
  const [page] = useContext(ServicoContext).page;
  const [size] = useContext(ServicoContext).size;

  const dispatch = useDispatch();
  const emPromocao =
    servico.promocao &&
    moment()
      .startOf('day')
      .isBetween(servico.promocao.vigenciaInicio, servico.promocao.vigenciaFim, undefined, '[]');

  const initialValues = {
    id: servico?.id,
    descricao: servico?.descricao || '',
    descricaoDetalhada: servico?.descricaoDetalhada || '',
    codigo: servico?.codigo || '',
    valorCusto: servico?.valorCusto || '',
    valorVenda: servico?.valorVenda || '',
    tipo: servico?.tipo || 'NONE',
    dataInativo: servico?.dataInativo || null,
    emPromocao: emPromocao || false,
    promocao: {
      vigenciaInicio:
        emPromocao && servico?.promocao?.vigenciaInicio ? moment(servico?.promocao?.vigenciaInicio) : null,
      vigenciaFim: emPromocao && servico?.promocao?.vigenciaFim ? moment(servico?.promocao?.vigenciaFim) : null,
      tipo: (emPromocao && servico?.promocao?.tipo) || 'VALOR',
      valor: (emPromocao && servico?.promocao?.valor) || '',
    },
    fiscal: {
      cnae: {
        id: servico?.fiscal?.cnae?.id || '',
        codigo: servico?.fiscal?.cnae?.codigo || '',
        descricao: servico?.fiscal?.cnae?.descricao || '',
      },
      lc116: {
        id: servico?.fiscal?.lc116?.id || '',
        codigo: servico?.fiscal?.lc116?.codigo || '',
        descricao: servico?.fiscal?.lc116?.descricao || '',
      },
      nbs: {
        id: servico?.fiscal?.nbs?.id || '',
        codigo: servico?.fiscal?.nbs?.codigo || '',
        descricao: servico?.fiscal?.nbs?.descricao || '',
      },
      ibsCbs: false,
      cstSituacaoTributaria: {
        id: servico?.fiscal?.cstSituacaoTributaria?.id || '',
        codigo: servico?.fiscal?.cstSituacaoTributaria?.codigo || '',
        descricao: servico?.fiscal?.cstSituacaoTributaria?.descricao || '',
        idSituacao: servico?.fiscal?.cstSituacaoTributaria?.idSituacao || '',
      },
      cstClassificacaoTributaria: {
        id: servico?.fiscal?.cstClassificacaoTributaria?.id || '',
        codigo: servico?.fiscal?.cstClassificacaoTributaria?.codigo || '',
        descricao: servico?.fiscal?.cstClassificacaoTributaria?.descricao || '',
        cstPaiId: servico?.fiscal?.cstClassificacaoTributaria?.cstPaiId || '',
      },
      possuiIbsCbs: servico?.fiscal?.possuiIbsCbs || false,

      codigoTributacaoNacional: {
        id: servico?.fiscal?.codigoTributacaoNacional?.id || '',
        codigo: servico?.fiscal?.codigoTributacaoNacional?.codigo || '',
        descricao: servico?.fiscal?.codigoTributacaoNacional?.descricao || '',
      },
      codigoServicoMunicipal: servico?.fiscal?.codigoServicoMunicipal || '',

      tipoIss: servico?.fiscal?.tipoIss || 'PERCENTUAL',
      valorIss: servico?.fiscal?.valorIss,
      issRetidoNaFonte: servico?.fiscal?.issRetidoNaFonte || false,

      tipoPis: servico?.fiscal?.tipoPis || 'PERCENTUAL',
      valorPis: servico?.fiscal?.valorPis,
      pisRetidoNaFonte: servico?.fiscal?.pisRetidoNaFonte || false,

      tipoCofins: servico?.fiscal?.tipoCofins || 'PERCENTUAL',
      valorCofins: servico?.fiscal?.valorCofins,
      cofinsRetidoNaFonte: servico?.fiscal?.cofinsRetidoNaFonte || false,

      tipoIrrf: servico?.fiscal?.tipoIrrf || 'PERCENTUAL',
      valorIrrf: servico?.fiscal?.valorIrrf,
      irrfRetidoNaFonte: servico?.fiscal?.irrfRetidoNaFonte || false,

      tipoInss: servico?.fiscal?.tipoInss || 'PERCENTUAL',
      valorInss: servico?.fiscal?.valorInss,
      inssRetidoNaFonte: servico?.fiscal?.inssRetidoNaFonte || false,

      tipoCsll: servico?.fiscal?.tipoCsll || 'PERCENTUAL',
      valorCsll: servico?.fiscal?.valorCsll,
      csllRetidoNaFonte: servico?.fiscal?.csllRetidoNaFonte || false,

      tipoIbs: servico?.fiscal?.tipoIbs || 'PERCENTUAL',
      valorIbs: servico?.fiscal?.valorIbs,
      ibsRetidoNaFonte: servico?.fiscal?.ibsRetidoNaFonte || false,

      tipoIbsMunicipal: servico?.fiscal?.tipoIbsMunicipal || 'PERCENTUAL',
      valorIbsMunicipal: servico?.fiscal?.valorIbsMunicipal,

      tipoCbs: servico?.fiscal?.tipoCbs || 'PERCENTUAL',
      valorCbs: servico?.fiscal?.valorCbs,
      cbsRetidoNaFonte: servico?.fiscal?.cbsRetidoNaFonte || false,

      tipoIs: servico?.fiscal?.tipoIs || 'PERCENTUAL',
      valorIs: servico?.fiscal?.valorIs,
      isRetidoNaFonte: servico?.fiscal?.isRetidoNaFonte || false,
    },
    naturezaOperacao: servico?.naturezaOperacao,
  };

  const servicoSchema = Yup.object().shape({
    fiscal: Yup.object().shape({
      valorIss: Yup.string()
        .nullable()
        .test('notNegativeValorIss', 'O valor do ISS não pode ser maior que o valor de venda.', function() {
          const tipoIss = formik.values?.fiscal?.tipoIss;
          const valorVenda = formik.values?.valorVenda;
          const issRetidoNaFonte = formik.values?.fiscal?.issRetidoNaFonte;

          if (tipoIss === 'VALOR' && valorVenda && issRetidoNaFonte) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.fiscal?.tipoIss,
              valorVenda,
              formik.values?.fiscal?.valorIss
            );

            return valorComDesconto >= 0;
          }

          return true;
        }),
      valorIrrf: Yup.string()
        .nullable()
        .test('notNegativeValorIrrf', 'O valor do IRRF não pode ser maior que o valor de venda.', function() {
          const tipoIrrf = formik.values?.fiscal?.tipoIrrf;
          const valorVenda = formik.values?.valorVenda;
          const irrfRetidoNaFonte = formik.values?.fiscal?.irrfRetidoNaFonte;

          if (tipoIrrf === 'VALOR' && valorVenda && irrfRetidoNaFonte) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.fiscal?.tipoIrrf,
              valorVenda,
              formik.values?.fiscal?.valorIrrf
            );

            return valorComDesconto >= 0;
          }

          return true;
        }),
      valorPis: Yup.string()
        .nullable()
        .test('notNegativeValorPis', 'O valor do PIS não pode ser maior que o valor de venda.', function() {
          const tipoPis = formik.values?.fiscal?.tipoPis;
          const valorVenda = formik.values?.valorVenda;
          const pisRetidoNaFonte = formik.values?.fiscal?.pisRetidoNaFonte;

          if (tipoPis === 'VALOR' && valorVenda && pisRetidoNaFonte) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.fiscal?.tipoPis,
              valorVenda,
              formik.values?.fiscal?.valorPis
            );

            return valorComDesconto >= 0;
          }

          return true;
        }),
      valorCofins: Yup.string()
        .nullable()
        .test('notNegativeValorCofins', 'O valor do COFINS não pode ser maior que o valor de venda.', function() {
          const tipoCofins = formik.values?.fiscal?.tipoCofins;
          const valorVenda = formik.values?.valorVenda;
          const cofinsRetidoNaFonte = formik.values?.fiscal?.cofinsRetidoNaFonte;

          if (tipoCofins === 'VALOR' && valorVenda && cofinsRetidoNaFonte) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.fiscal?.tipoCofins,
              valorVenda,
              formik.values?.fiscal?.valorCofins
            );

            return valorComDesconto >= 0;
          }

          return true;
        }),
      valorInss: Yup.string()
        .nullable()
        .test('notNegativeValorInss', 'O valor do INSS não pode ser maior que o valor de venda.', function() {
          const tipoInss = formik.values?.fiscal?.tipoInss;
          const valorVenda = formik.values?.valorVenda;
          const inssRetidoNaFonte = formik.values?.fiscal?.inssRetidoNaFonte;

          if (tipoInss === 'VALOR' && valorVenda && inssRetidoNaFonte) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.fiscal?.tipoInss,
              valorVenda,
              formik.values?.fiscal?.valorInss
            );

            return valorComDesconto >= 0;
          }

          return true;
        }),
      valorCsll: Yup.string()
        .nullable()
        .test('notNegativeValorCsll', 'O valor do CSLL não pode ser maior que o valor de venda.', function() {
          const tipoCsll = formik.values?.fiscal?.tipoCsll;
          const valorVenda = formik.values?.valorVenda;
          const csllRetidoNaFonte = formik.values?.fiscal?.csllRetidoNaFonte;

          if (tipoCsll === 'VALOR' && valorVenda && csllRetidoNaFonte) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.fiscal?.tipoCsll,
              valorVenda,
              formik.values?.fiscal?.valorCsll
            );

            return valorComDesconto >= 0;
          }

          return true;
        }),
      cstSituacaoTributaria: Yup.object({
        id: Yup.string().nullable(),
      })
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema.test('cstSituacaoTributaria', 'Informe o código de situação tributária', (obj) => {
              if (!obj) return false;
              return !!obj.id;
            }),
        }),
      cstClassificacaoTributaria: Yup.object()
        .nullable()
        .when('cstSituacaoTributaria.id', {
          is: (id) => Boolean(id),
          then: (schema) => schema.required('Informe o código de classificação tributária'),
          otherwise: (schema) => schema.notRequired(),
        }),
      valorIbs: Yup.number()
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema
              .required(mensagemCampoObrigatorio('o valor do IBS'))
              .min(0)
              .max(100),
        }),
      valorCbs: Yup.number()
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema
              .required(mensagemCampoObrigatorio('o valor do CBS'))
              .min(0)
              .max(100),
        }),
      valorIs: Yup.number()
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema
              .required(mensagemCampoObrigatorio('o valor do IS'))
              .min(0)
              .max(100),
        }),
      // valorIbs: Yup.string()
      //   .nullable()
      //   .test('notNegativeValorIbs', 'O valor do IBS não pode ser maior que o valor de venda.', function() {
      //     const tipoIbs = formik.values?.fiscal?.tipoIbs;
      //     const valorVenda = formik.values?.valorVenda;
      //     const ibsRetidoNaFonte = formik.values?.fiscal?.ibsRetidoNaFonte;

      //     if (tipoIbs === 'VALOR' && valorVenda && ibsRetidoNaFonte) {
      //       const valorComDesconto = calcularValorComDesconto(
      //         formik.values?.fiscal?.tipoIbs,
      //         valorVenda,
      //         formik.values?.fiscal?.valorIbs
      //       );

      //       return valorComDesconto >= 0;
      //     }

      //     return true;
      //   }),
      // valorCbs: Yup.string()
      //   .nullable()
      //   .test('notNegativeValorCbs', 'O valor do CBS não pode ser maior que o valor de venda.', function() {
      //     const tipoCbs = formik.values?.fiscal?.tipoCbs;
      //     const valorVenda = formik.values?.valorVenda;
      //     const cbsRetidoNaFonte = formik.values?.fiscal?.cbsRetidoNaFonte;

      //     if (tipoCbs === 'VALOR' && valorVenda && cbsRetidoNaFonte) {
      //       const valorComDesconto = calcularValorComDesconto(
      //         formik.values?.fiscal?.tipoCbs,
      //         valorVenda,
      //         formik.values?.fiscal?.valorCbs
      //       );

      //       return valorComDesconto >= 0;
      //     }

      //     return true;
      //   }),
      // valorIs: Yup.string()
      //   .nullable()
      //   .test('notNegativeValorIs', 'O valor do IS não pode ser maior que o valor de venda.', function() {
      //     const tipoIs = formik.values?.fiscal?.tipoIs;
      //     const valorVenda = formik.values?.valorVenda;
      //     const isRetidoNaFonte = formik.values?.fiscal?.isRetidoNaFonte;

      //     if (tipoIs === 'VALOR' && valorVenda && isRetidoNaFonte) {
      //       const valorComDesconto = calcularValorComDesconto(
      //         formik.values?.fiscal?.tipoIs,
      //         valorVenda,
      //         formik.values?.fiscal?.valorIs
      //       );

      //       return valorComDesconto >= 0;
      //     }

      //     return true;
      //   }),
    }),
    descricao: Yup.string()
      .nullable()
      .required(mensagemCampoObrigatorio('o nome do serviço prestado'))
      .min(3, 'É necessário informar pelo menos 3 caracteres no campo')
      .max(50, 'Não pode ultrapassar 50 caracteres'),
    codigo: Yup.string()
      .nullable()
      .max(20, 'Não pode ultrapassar 20 caracteres')
      .test('codigo', mensagemCampoObrigatorio('o código do serviço'), function(codigo) {
        if (this.parent?.id && !codigo) {
          return false;
        }
        return true;
      }),
    tipo: Yup.string().nullable(),
    valorCusto: Yup.number().nullable(),
    valorVenda: Yup.number()
      .nullable()
      .test('valorVendaPreenchido', 'Informe o valor de venda para ser aplicado o desconto.', function() {
        if (formik.values?.valorCusto && !formik.values?.valorVenda) {
          return false;
        }

        return true;
      })
      .test('ltValorCusto', 'O valor da venda não pode ser menor que o valor do custo', function() {
        if (!formik.values?.valorCusto) {
          return true;
        }
        if (!formik.values?.valorVenda) {
          return true;
        }
        if (formik.values?.valorCusto > formik.values?.valorVenda) {
          return false;
        }

        return true;
      }),
    descricaoDetalhada: Yup.string()
      .nullable()
      .max(500, 'Não pode ultrapassar 500 caracteres')
      .min(3, 'É necessário informar pelo menos 3 caracteres no campo'),
    promocao: Yup.object().shape({
      vigenciaInicio: Yup.object()
        .nullable()
        .test('validRange', mensagemCampoObrigatorio('o período'), function() {
          if (!formik.values.emPromocao) {
            return true; // true se não está em promoção
          }
          if (!formik.values.promocao?.vigenciaInicio || !formik.values.promocao?.vigenciaFim) {
            return false; // false se está em promoção, mas não possui o período selecionado
          }
          return true; // true caso está em promoção e tem período selecionado
        }),
      valor: Yup.string()
        .nullable()
        .test('validValue', mensagemCampoObrigatorio('o valor'), function() {
          if (!formik.values.emPromocao) {
            return true; // true se não está em promoção
          }
          if (!formik.values.promocao?.valor) {
            if (formik.values.promocao?.valor === 0) {
              return true; // true se está em promoção e o valor for 0 (diferente de null e undefined)
            }
            return false; // false se null ou undefined
          }
          return true; // true se em promoção e possui valor
        })
        .test('notNegative', 'O valor de desconto não pode ser maior que o valor da venda.', function() {
          if (!formik.values.emPromocao) {
            return true;
          }

          if (formik.values.valorVenda) {
            const valorComDesconto = calcularValorComDesconto(
              formik.values?.promocao?.tipo,
              formik.values?.valorVenda,
              formik.values?.promocao?.valor
            );
            return valorComDesconto >= 0;
          }
          return true;
        })
        .test('semValorDeVenda', INFORME_O_VALOR, function() {
          const { valorVenda } = formik.values;
          const valorPromocao = formik.values?.promocao?.valor;
          if (valorPromocao && !valorVenda) {
            return false;
          }
          return true;
        }),
    }),
  });

  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const validarRetencoesValor = (data) => {
    const valorVenda = formik.values?.valorVenda;

    let somatorio = 0;

    if (data.fiscal?.tipoIss === 'VALOR' && data.fiscal?.issRetidoNaFonte) {
      somatorio += data.fiscal?.valorIss;
    }

    if (data.fiscal?.tipoIrrf === 'VALOR' && data.fiscal?.irrfRetidoNaFonte) {
      somatorio += data.fiscal?.valorIrrf;
    }

    if (data.fiscal?.tipoPis === 'VALOR' && data.fiscal?.pisRetidoNaFonte) {
      somatorio += data.fiscal?.valorPis;
    }

    if (data.fiscal?.tipoCofins === 'VALOR' && data.fiscal?.cofinsRetidoNaFonte) {
      somatorio += data.fiscal?.valorCofins;
    }

    if (data.fiscal?.tipoInss === 'VALOR' && data.fiscal?.inssRetidoNaFonte) {
      somatorio += data.fiscal?.valorInss;
    }

    if (data.fiscal?.tipoCsll === 'VALOR' && data.fiscal?.csllRetidoNaFonte) {
      somatorio += data.fiscal?.valorCsll;
    }

    const diferenca = valorVenda - somatorio;

    if (diferenca < 0) {
      showError('A soma das retenções do tipo nominal não podem ultrapassar o valor de venda do serviço.');
      return false;
    }

    return true;
  };

  const validarRetencoesPercentual = (data) => {
    let somatorio = 0;

    if (data.fiscal?.tipoIss === 'PERCENTUAL' && data.fiscal?.issRetidoNaFonte) {
      somatorio += data.fiscal?.valorIss;
    }

    if (data.fiscal?.tipoIrrf === 'PERCENTUAL' && data.fiscal?.irrfRetidoNaFonte) {
      somatorio += data.fiscal?.valorIrrf;
    }

    if (data.fiscal?.tipoPis === 'PERCENTUAL' && data.fiscal?.pisRetidoNaFonte) {
      somatorio += data.fiscal?.valorPis;
    }

    if (data.fiscal?.tipoCofins === 'PERCENTUAL' && data.fiscal?.cofinsRetidoNaFonte) {
      somatorio += data.fiscal?.valorCofins;
    }

    if (data.fiscal?.tipoInss === 'PERCENTUAL' && data.fiscal?.inssRetidoNaFonte) {
      somatorio += data.fiscal?.valorInss;
    }

    if (data.fiscal?.tipoCsll === 'PERCENTUAL' && data.fiscal?.csllRetidoNaFonte) {
      somatorio += data.fiscal?.valorCsll;
    }

    if (somatorio > 100) {
      showError('A soma das retenções do tipo percentual não podem ultrapassar 100%.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (data) => {
    if (data?.fiscal?.cnae?.id) {
      data.fiscal.cnaeId = data.fiscal.cnae.id;
    }

    if (data?.fiscal?.lc116?.id) {
      data.fiscal.lc116Id = data.fiscal.lc116.id;
    }

    if (data?.fiscal?.nbs?.id) {
      data.fiscal.nbsId = data.fiscal.nbs.id;
    }

    if (data?.fiscal?.cstSituacaoTributaria?.id) {
      data.fiscal.cstSituacaoTributariaId = data.fiscal.cstSituacaoTributaria.id || null;
    }

    if (data?.fiscal?.cstClassificacaoTributaria?.id) {
      data.fiscal.cstClassificacaoTributariaId = data.fiscal.cstClassificacaoTributaria.id || null;
    }

    if (data?.fiscal?.codigoTributacaoNacional?.id) {
      data.fiscal.codigoTributacaoNacionalId = data.fiscal.codigoTributacaoNacional.id;
    }

    if (!data.emPromocao) {
      delete data.promocao;
    }

    const isValidadoRetencoesPercentual = validarRetencoesPercentual(data);
    const isValidadoRetencoesValor = isValidadoRetencoesPercentual ? validarRetencoesValor(data) : false;
    const isUtilizadoIbsCbs =
      data?.fiscal?.cstSituacaoTributariaId ||
      data?.fiscal?.cstClassificacaoTributariaId ||
      data?.fiscal?.valorIbs > 0 ||
      data?.fiscal?.valorIbsMunicipal > 0 ||
      data?.fiscal?.valorCbs > 0 ||
      data?.fiscal?.valorIs > 0;

    data.fiscal.possuiIbsCbs = !!isUtilizadoIbsCbs;

    if (isValidadoRetencoesPercentual && isValidadoRetencoesValor) {
      const res = await onSubmit(data, { q: search, page, size });

      if (res) {
        close();
      }
    }
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    validationSchema: servicoSchema,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues,
  });

  const close = () => {
    formik.resetForm(initialValues);
    setTabSelecionada(tabs.dadosServico);
    setModal('');
  };

  useEffect(() => {
    setFuncaoClose(close);
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setFuncaoClose]);

  const handleClose = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  useEffect(() => {
    formik.resetForm(initialValues);
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [servico]);

  const Buttons = (
    <>
      <CancelButton title="cancelar" type="button" onClick={handleClose}>
        Cancelar
      </CancelButton>
      <SaveButton color="buttonSave" type="submit">
        Salvar
      </SaveButton>
    </>
  );

  const handleMensagem = (notificacao) => {
    if (idNotificacao === notificacao.id) {
      if (isNaN(notificacao?.mensagem)) {
        setOpenLoadingModal(false);
        showError(notificacao.mensagem);
      } else {
        setProgressoLoading(notificacao?.mensagem);
        let porcentagem = parseFloat(notificacao?.mensagem);
        if (porcentagem === 100) {
          setOpenLoadingModal(false);
          showSuccess('Serviço editado com sucesso.');
          close();
        }
      }
    }
  };

  return (
    <>
      <FormikProvider value={formik}>
        <SimpleDialog fullScreen open={modal === servicoModais.editarServicoModal} onClose={handleClose}>
          <FormDialogContent
            onSubmit={formik.handleSubmit}
            fullScreen
            contentToolbar={
              <Abas
                value={tabSelecionada}
                onChange={(tabIndex) => {
                  setTabSelecionada(tabIndex);
                }}
                tabs={[
                  {
                    label: 'Dados do Serviço',
                    hasError: () => {
                      const dadosServicoErrors = Object.entries(formik.errors || {}).filter(
                        (key) => key !== 'fiscal' || key !== 'promocao'
                      );
                      const promocaoErrors = Object.entries(formik.errors?.promocao || {});

                      return !!(dadosServicoErrors.length || promocaoErrors.length);
                    },
                  },
                  {
                    label: 'Dados fiscais',
                    hasError: () => {
                      const fiscalErrors = Object.entries(formik.errors?.fiscal || {});
                      return !!fiscalErrors.length;
                    },
                  },
                ]}
              />
            }
            header={{ title: 'Cadastro de serviço', icon: <ServicoIcon />, toolbar: Buttons }}
            content={
              <>
                {tabSelecionada === tabs.dadosServico && <TabDadosServico />}
                {tabSelecionada === tabs.dadosFiscais && <TabDadosFiscaisServico />}
              </>
            }
          />
        </SimpleDialog>
      </FormikProvider>

      <LoadingModal
        open={openLoadingModal}
        progress={progressoLoading}
        mensagem={'Aplicando os ajustes nos contratos e vendas...'}
      />
      <SockJsClient
        url={`${process.env.REACT_APP_WEBSOCKET_URL}`}
        topics={['/topic/notificacao']}
        onConnect={() => {
          console.log('Connected');
        }}
        onDisconnect={() => {
          console.log('Disconnected');
        }}
        onMessage={(notificacao) => {
          console.log('Message:', notificacao);
          handleMensagem(notificacao);
        }}
      />
    </>
  );
};

export default EditarServicoModal;
